module.exports = __webpack_public_path__ + "static/media/image_50.80cab51e.png";